const KEY = "lw.proLicense";
export const API = process.env.REACT_APP_BACKEND_URL;

export const getLicense = () => localStorage.getItem(KEY) || "";
export const setLicense = (k) => { localStorage.setItem(KEY, k); window.dispatchEvent(new Event("lw-pro")); };
export const isPro = () => !!getLicense();
export const PAYPAL_ME = process.env.REACT_APP_PAYPAL_ME || "";
export const paypalMeUrl = (amount) => `https://paypal.me/${encodeURIComponent(PAYPAL_ME)}${Number(amount) > 0 ? `/${Number(amount).toFixed(2)}SGD` : ""}`;
export const deviceId = () => {
  let d = localStorage.getItem("lw.deviceId");
  if (!d) { d = crypto.randomUUID(); localStorage.setItem("lw.deviceId", d); }
  return d;
};
export const isDesktop = () => !/^https?:$/.test(window.location.protocol);
export const webOrigin = () => (isDesktop() ? API : window.location.origin);

export async function post(path, body) {
  const r = await fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw Object.assign(new Error(typeof j.detail === "string" ? j.detail : `Request failed (${r.status})`), { status: r.status });
  return j;
}

export async function get(path) {
  const r = await fetch(`${API}${path}`);
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw Object.assign(new Error(typeof j.detail === "string" ? j.detail : `Request failed (${r.status})`), { status: r.status });
  return j;
}

export async function recheckLicense() {
  const k = getLicense();
  if (!k || !navigator.onLine) return;
  try { const { valid } = await post("/api/license/verify", { key: k, device_id: deviceId() }); if (!valid) setLicense(""); } catch { /* keep offline */ }
}

export async function verifyLicense(key) {
  const k = key.trim().toUpperCase();
  const r = await post("/api/license/verify", { key: k, device_id: deviceId() });
  if (r.valid) {
    setLicense(k);
    window.dispatchEvent(new CustomEvent("lw-activation", { detail: { key: k, ...r } }));
  }
  return r.valid;
}

let ppCache = null;
export const paypalEnabled = () => (ppCache ??= get("/api/paypal/config").then((r) => r.enabled).catch(() => false));

export async function buyProPaypal(promo_code = "") {
  if (!navigator.onLine) throw new Error("You are offline. Connect to the internet to buy Pro.");
  const { approve_url } = await post("/api/paypal/pro/order", { origin_url: webOrigin(), promo_code });
  if (isDesktop()) window.open(approve_url, "_blank");
  else window.location.href = approve_url;
}

export async function buyPro(promo_code = "") {
  if (!navigator.onLine) throw new Error("You are offline. Connect to the internet to buy Pro.");
  const { checkout_url } = await post("/api/payments/pro/checkout", { origin_url: webOrigin(), promo_code });
  if (isDesktop()) window.open(checkout_url, "_blank");
  else window.location.href = checkout_url;
}
